module.exports = __webpack_public_path__ + "static/multicopter-urban-air-mobility-short-range-fde2da4f205f18eed111e6b7f3f53b1c.png";